<template>
  <div class="dashboard">
    <sidebar />
    <div class="container col-10">
      <template>
        <v-row justify="end">
          <v-col cols="auto" class="centered-column px-25">
            <changePassSecurity/>
          </v-col>
          <v-col cols="auto" class="centered-column px-0">
            <menuUserCompany/>
          </v-col>
          <v-col cols="auto" class="centered-column px-0">
            <notifications/>
          </v-col>
        </v-row>
      </template>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

import notifications from "@/shared/components/notifications/notifications_component.vue";
import menuUserCompany from "@/shared/components/menu_user_company/menu_user_company_component.vue";
import changePassSecurity from '@/views/change_password_security/pages/detail_change_pass_security_page.vue';

import sidebar from "@/shared/components/sidebar/sidebar_component.vue";

export default {
  name: "dashboard",
  components: {
    sidebar,
    notifications,
    menuUserCompany,
    changePassSecurity
  },
};
</script>

<style lang="css">
  .dashboard {
    height: 100%;
    background
    : #f9fdff;
  }
  body {
    font-family: "Amsi Pro", sans-serif;
  }

  .centered-column {
  display: flex;
  justify-content: center; /* Centra horizontalmente */
  align-items: center; /* Centra verticalmente */
}
</style>
